import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useState } from "react";
import { FileText } from "lucide-react";
import { PolicyTypeDialogForm } from "./PolicyTypeDialogForm";

interface PolicyTypeHeaderProps {
  onAddClick: () => void;
  onPolicyLineAdded?: () => void;
}

export const PolicyTypeHeader = ({ onAddClick, onPolicyLineAdded }: PolicyTypeHeaderProps) => {
  const [showDialog, setShowDialog] = useState(false);

  return (
    <>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold">Manage Policy Types</h2>
        <Button onClick={() => setShowDialog(true)} className="text-white">
          <FileText className="mr-2" />
          Add Policy Type
        </Button>
      </div>

      <Dialog open={showDialog} onOpenChange={setShowDialog}>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle>Add Policy Type</DialogTitle>
          </DialogHeader>
          <PolicyTypeDialogForm 
            onClose={() => setShowDialog(false)}
            onPolicyLineAdded={onPolicyLineAdded}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};